import type { Models } from 'umi';
import { hasOwnPeriod, hasSharePeriod, hasCheckAgree } from '@/services/period';

export default function userAccess(
  initialState: Models<'@@initialState'>['initialState']
) {
  const {
    role,
    showCheckToolAuth,
    menuAuth,
    // verify,
    walletInfo,
    batchGrayList,
    accountPeriod,
    epAuthData,
    hasOrderApproveEquity,
  } = initialState || {};

  // 单独处理： 只能在react函数组件/自定义hook中调用hook

  return {
    // 菜单权限 ------------------------------------------- start
    // 首页
    canShowHome() {
      return role === '1' || role === '2' || role === '3' || role === '100';
    },
    // 数据中心
    canShowDataCenter() {
      return batchGrayList?.pc_big_screen && role === '1';
    },
    canShowDataBigScreen() {
      return batchGrayList?.pc_big_screen && role === '1';
    },
    // 订单中心
    canShowOrderCenter() {
      return role === '1' || role === '2' || role === '3' || role === '100';
    },
    canShowOrderCenterSameCity() {
      return role === '1' || role === '2' || role === '3' || role === '100';
    },
    // 订单列表（新）
    canShowOrderCenterOrderListNew() {
      return role === '1' || role === '2' || role === '3' || role === '100';
    },
    // 审批中心
    canShowOrderCenterOrderApproval() {
      return hasOrderApproveEquity;
    },
    // 费用说明（新）
    canShowOrderCenterOrderChargeNew() {
      return role === '1' || role === '2' || role === '3' || role === '100';
    },
    // 订单配置
    canShowOrderConfigFavorityDriver() {
      return (
        !batchGrayList?.pc_favorite_driver_list &&
        (role === '1' || role === '2' || role === '3' || role === '100')
      );
    },
    // 收藏司机新
    canShowOrderConfigFavorityDriverNew() {
      return (
        batchGrayList?.pc_favorite_driver_list &&
        (role === '1' || role === '2' || role === '3' || role === '100')
      );
    },
    canShowOrderConfigUserCarReasonSetting() {
      return role === '1';
    },
    // 企业管理
    canShowCompanyManage() {
      return role === '1';
    },
    canShowCompanyManageCompanyVerify() {
      return role === '1';
    },
    canShowCompanyManageSuperManagerTransfer() {
      return role === '1';
    },
    canShowCompanyMagageCompanyUnregister() {
      return role === '1';
    },
    // 组织架构
    canShowStaffOrganization() {
      return (
        role === '1' ||
        role === '3' ||
        menuAuth?.some((item) => [4, 6].includes(item.permissionCode))
      );
    },
    // 企业关联
    canShowStaffOrganizationCompanyAssociate() {
      return role === '1' && !batchGrayList?.pc_ep_relation;
    },
    // 企业关联新版
    canShowStaffOrganizationCompanyAssociateNew() {
      return role === '1' && batchGrayList?.pc_ep_relation;
    },
    // 员工管理
    canShowStaffOrganizationStaffManage() {
      return (
        role === '1' ||
        role === '3' ||
        menuAuth?.some((item) => item.permissionCode === 4)
      );
    },
    // 部门管理
    canShowStaffOrganizationDepartmentManage() {
      return (
        role === '1' || menuAuth?.some((item) => item.permissionCode === 6)
      );
    },
    // 财务中心
    canShowFinanceManage() {
      return role === '1' || role === '2' || role === '3' || role === '100';
    },
    // 钱包充值
    canShowFinanceManageRechargeOnlineNew() {
      return (
        role === '1' || menuAuth?.some((item) => item.permissionCode === 2)
      );
    },
    // 流水记录
    canShowFinanceManageFinancialFlowNew() {
      return (
        role === '1' || menuAuth?.some((item) => item.permissionCode === 3)
      );
    },
    // 发票管理
    canShowFinanceManageInvoiceApply() {
      return (
        (role === '1' || menuAuth?.some((item) => item.permissionCode === 1)) &&
        !batchGrayList?.pc_invoice
      );
    },
    // 发票管理(新)
    canShowFinanceManageInvoiceApplyNew() {
      return (
        (role === '1' || menuAuth?.some((item) => item.permissionCode === 1)) &&
        batchGrayList?.pc_invoice
      );
    },
    canShowFinanceManageCoupon() {
      return role === '1' || role === '2' || role === '3' || role === '100';
    },
    canShowBalanceWarning() {
      return role === '1';
    },
    // 支付方式设置
    canShowPaywaySetting() {
      return role === '1' && hasOrderApproveEquity;
    },
    // 菜单权限 ------------------------------------------- end

    // 其它权限 ------------------------------------------- start
    // 钱包
    canShowWallet() {
      return role === '1';
    },
    // 财务管理-对账工具
    canShowCheckTool() {
      return showCheckToolAuth;
    },
    // 权限管理:在灰度范围内的超管,并且当前企业是已认证状态
    canShowRightsManage() {
      return role === '1';
    },
    // 财务管理-月结管理--------------------------------- start
    // 月结管理
    canShowMonthlyManage() {
      return (
        role === '1' &&
        (hasOwnPeriod(walletInfo?.ownPeriodStatus) ||
          hasSharePeriod(walletInfo?.sharePeriodStatus))
      );
    },
    // 月结账单
    canShowMonthBill() {
      return hasOwnPeriod(walletInfo?.ownPeriodStatus);
    },
    // 共享月结账单
    canShowShareBill() {
      return hasSharePeriod(walletInfo?.sharePeriodStatus);
    },
    // 账户信息
    canShowAccountInfo() {
      // 新账期隐藏
      return accountPeriod?.isHPay !== 1;
    },
    // 授权委托
    canShowPaymentAgree() {
      // 中高频异常已认证企业 && (管理员或有充值权限的员工)
      return hasCheckAgree(epAuthData || {}) && (role === '1' || menuAuth?.some((item) => item.permissionCode === 2));
    },
    // 财务管理-月结账单 --------------------------------- end
    // 其它权限 ------------------------------------------- end
  };
}
